import { Card, CardContent } from '@/components/ui/Card';
import { StatusIndicator } from '@/components/ui/StatusIndicator';
import type { ServiceHealth } from '@/types/admin.types';

type IndicatorStatus = 'healthy' | 'degraded' | 'down' | 'success' | 'warning' | 'error' | 'neutral';

interface ServiceStatusCardProps {
  service: ServiceHealth;
}

export function ServiceStatusCard({ service }: ServiceStatusCardProps) {
  // Map service status to a known indicator status, defaulting to 'neutral'
  const validStatuses: IndicatorStatus[] = ['healthy', 'degraded', 'down', 'success', 'warning', 'error', 'neutral'];
  const indicatorStatus: IndicatorStatus = validStatuses.includes(service.status as IndicatorStatus)
    ? (service.status as IndicatorStatus)
    : 'neutral';

  return (
    <Card>
      <CardContent>
        <div className="flex items-center justify-between">
          <StatusIndicator status={indicatorStatus} label={service.name} />
          <span className="text-xs text-neutral-500">{service.latency}ms</span>
        </div>
      </CardContent>
    </Card>
  );
}
